<template>
    <!-- Side Navigation -->
    <div class="content-side content-side-full">
        <ul class="nav-main">
            <li v-for="(item, index) in navItems" :key="index" class="nav-main-item" :class="{'open': isActive(item)} ">
                <template v-if="renderMenuItem(item) && !Array.isArray(item.children) && hasApi(item.allowedApis || [])">
                    <router-link class="nav-main-link" :to="item.url" >
                        <i class="nav-main-link-icon" :class="item.icon"></i>
                        <span @click="toggleSidebar" class="nav-main-link-name">{{item.title}}</span>
                    </router-link>
                </template>
                <template v-if="Array.isArray(item.children) && renderMenuItem(item)  && hasApi(item.allowedApis || [])">
                    <a class="nav-main-link nav-main-link-submenu" data-toggle="submenu" aria-haspopup="true"
                       aria-expanded="true" href="javascript:void">
                        <i class="nav-main-link-icon" :class="item.icon"></i>
                        <span class="nav-main-link-name">{{item.title}}</span>
                    </a>
                    <ul class="nav-main-submenu ">
                        <li class="nav-main-item" v-for="(child, key) in item.children" :key="key" v-if="renderMenuItem(child) && hasApi(child.allowedApis || []) ">
                            <router-link class="nav-main-link"
                                         :to="child.url">
                                <span @click="toggleSidebar" class="nav-main-link-name">{{child.title}}</span>
                            </router-link>
                        </li>
                    </ul>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import { isMobile } from 'mobile-device-detect';

    export default {
        props: {
            navItems: Array
        },
        computed : {
            ...mapGetters({
                project: 'getProject',
                projectUser: 'getProjectUser',
            })
        },

        name: 'ui-navigation',
        methods: {
            hasProjectAccess(roles) {
                return _.includes(roles, this.projectUser.access);
            },

            toggleSidebar() {
                if(isMobile) {
                    window.App.layout('sidebar_close');
                }
            },


            renderMenuItem(item) {
                let hasAccess = true;
                if(Array.isArray(item.roles)) {
                    hasAccess = false;
                    item.roles.forEach(role => {
                        if(this.$hasRole(role)) {
                            hasAccess = true;
                        }
                    })
                }
                if(Array.isArray(item.projectAccess)) {
                    hasAccess = this.hasProjectAccess(item.projectAccess);
                }
                if(item.hasOwnProperty('env')) {
                    hasAccess = _.includes(item.env, process.env.NODE_ENV);
                }
                return hasAccess;
            },
            /**
             * Determine if a navigation item should be displayed when the API is enabled on Project
             *
             * @param apis
             * @returns {boolean}
             */
            hasApi(apis) {
                let  projectAccess = true, project = this.$store.getters.getProject;
                if(Array.isArray(apis) && apis.length > 0 ) {
                    projectAccess = false;
                    apis.forEach(api => {
                        if(_.includes(project.apis, api)) {
                            projectAccess = true;
                        }
                    })
                }
                return projectAccess;
            },
            /**
             *  Determine if the current nav link is active
             *
             * @param item
             * @returns {boolean}
             */
            isActive(item) {
                if (!Array.isArray(item.children)) {
                    return false
                }
                const paths = Array.isArray(item.path) ? item.path : [item.path];
                let pattern;
                return paths.some(path => {
                    pattern = RegExp(`^${path}`);

                    return pattern.test(this.$route.path);
                })
            },
            getSafe(fn) {
                try {
                    return fn();
                } catch (e) {
                    return undefined;
                }
            }
        }
    }
</script>

<style scoped>

</style>
